import { classLevels } from '../../../constants'

import allCategories from '../../../assets/icon/allCategories.svg'
import blockchainDevelopment from '../../../assets/icon/blockchainDevelopment.svg'
import cryptoBasis from '../../../assets/icon/cryptoBasis.svg'
import defl from '../../../assets/icon/defl.svg'
import metaverse from '../../../assets/icon/metaverse.svg'
import nft from '../../../assets/icon/nft.svg'
import smartContracts from '../../../assets/icon/smartContracts.svg'
import trading from '../../../assets/icon/trading.svg'
import dao from '../../../assets/icon/dao.svg'

export const findTutorCategories = [
  {
    slug: '_',
    name: 'All Categories',
    image: allCategories,
  },
  {
    slug: 'cryptocurrencies-basic',
    name: 'Crypto Basics',
    image: cryptoBasis,
  },
  {
    slug: 'metaverse',
    name: 'Metaverse',
    image: metaverse,
  },
  {
    slug: 'nft',
    name: 'NFT',
    image: nft,
  },
  {
    slug: 'trading',
    name: 'Trading',
    image: trading,
  },
  {
    slug: 'defi',
    name: 'DeFi',
    image: defl,
  },
  {
    slug: 'dao',
    name: 'DAO',
    image: dao,
  },
  {
    slug: 'blockchain-development',
    name: 'Blockchain Development',
    image: blockchainDevelopment,
  },
  {
    slug: 'smart-contracts',
    name: 'Smart Contracts',
    image: smartContracts,
  },
]

export const sortOptions = [
  {
    value: 'name_a_z',
    label: 'Name A-Z',
  },
  {
    value: 'name_z_a',
    label: 'Name Z-A',
  },
  {
    value: 'price_low_high',
    label: 'Price low-high',
  },
  {
    value: 'price_high_low',
    label: 'Price high-low',
  },
  {
    value: 'highest_rating',
    label: 'Highest Rating',
  },
  {
    value: 'lowest_rating',
    label: 'Lowest Rating',
  },
  {
    value: 'more_classes_completed',
    label: 'More Classes Completed',
  },
  {
    value: 'less_classes_completed',
    label: 'Less Classes Completed',
  },
  {
    value: 'most_students',
    label: 'Most Students',
  },
  {
    value: 'least_students',
    label: 'Least Students',
  },
  {
    value: 'highest_roi',
    label: 'Highest ROI Percentage',
  },
  {
    value: 'Lowest_roi',
    label: 'Lowest ROI Percentage',
  },
]

export const tutorRatings = [
  {
    value: '_',
    label: 'Any Rating',
  },
  {
    value: '5',
    label: '5 Stars',
  },
  {
    value: '4__5',
    label: '4 - 5 Stars',
  },
  {
    value: '3__4',
    label: '3 - 4 Stars',
  },
  {
    value: '2__3',
    label: '2 - 3 Stars',
  },
  {
    value: '1__2',
    label: '1 - 2 Stars',
  },
]

export const tutorPrices = [
  {
    value: '_',
    label: 'Any Price',
  },
  {
    value: '0__10',
    label: '€ 0 - € 10',
  },
  {
    value: '10__25',
    label: '€ 10 - € 25',
  },
  {
    value: '25__50',
    label: '€ 25 - € 50',
  },
  {
    value: '50__100',
    label: '€ 50 - € 100',
  },
  {
    value: '100',
    label: '€ 100 and above',
  },
]

export const tutorClassLevels = [
  {
    value: '_',
    label: 'Any Level',
  },
  ...classLevels,
]
